<template lang="html">
  <div>
    <highcharts :options="chartOptions_1"></highcharts>
    <highcharts :options="chartOptions_2"></highcharts>
    <highcharts :options="chartOptions_3"></highcharts>
  </div>
</template>

<script>


  export default {
    props : ["player_throw_divide_data"],
    data(){
      return {
        chartOptions_1: {
              chart: {
                  backgroundColor: '#F8CB2E',
                  type: 'area',
                  height: 200,
              },
                title: {
                    text: "Aloitusheitot",
                    align: 'left',
                    margin: 0,
                    x: 30
                },
              legend: {
                enabled : false
              },

              credits:{enabled:false},
              xAxis: [{
                  tickInterval: 1,
                }],

              yAxis: [{
                title: {
                    text: ''
                  },

              }],
              series: [
              ],
              tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.y} kpl {point.x} kyykän poistoja'
              },
              plotOptions: {
                      series: {
                          label: {
                              connectorAllowed: false
                          },
                      }
                  },
          },            
          chartOptions_2: {
              chart: {
                  backgroundColor: '#F8CB2E',
                  type: 'area',
                  height: 200,
              },
                title: {
                    text: '>40 jäljellä',
                    align: 'left',
                    margin: 0,
                    x: 30
                },
              legend: {
                enabled : false
              },
              credits:{enabled:false},
              xAxis: [{
                  tickInterval: 1,


                  // min: -120,
              },
              ],

              yAxis: [{
                title: {
                    text: ''
                  },
              }],
              series: [
              ],
              tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.y} kpl {point.x} kyykän poistoja'
              },
              plotOptions: {
                      series: {
                          label: {
                              connectorAllowed: false
                          },
                      }
                  },
          },          
          chartOptions_3: {
              chart: {
                  backgroundColor: '#F8CB2E',
                  type: 'area',
                  height: 200,
              },
                title: {
                    text: '<40 jäljellä',
                    align: 'left',
                    margin: 0,
                    x: 30
                },
              legend: {
                enabled : false
              },
              credits:{enabled:false},
              xAxis: [{
                  tickInterval: 1,
              }],
              yAxis: [{
                title: {
                    text: ''
                  },

              }],
              series: [
              ],
              tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.y} kpl {point.x} kyykän poistoja'
              },
              plotOptions: {
                      series: {
                          label: {
                              connectorAllowed: false
                          },
                      }
                  },
          },        


      }
    },
    methods: {
      parse_values(data) {
        // console.log(data[0])
        this.chartOptions_1.series = [{
          data: data[0],
          color: '#2b7fe0',
          yAxis:0,
                marker: {
                  enabled: false
                }
          }]        
        this.chartOptions_2.series = [{
          data: data[1],
          color: '#80E02B',
          yAxis:0,
                marker: {
                  enabled: false
                }
          }]        
        this.chartOptions_3.series = [{
          data: data[2],
          color: '#e0322b',
          yAxis:0,
                marker: {
                  enabled: false
                }
          }]
        // },{
        //   name: '>40 jäljellä',
        //   data: data[1],
        //   color: '#80E02B',
        //   yAxis:1,
        // },{
        //   name: '<40 jäljellä',
        //   data: data[2],
        //   color: '#e0322b',
        //   yAxis:2,
        // }
        // ]
  
      },
    },
    watch: {
      player_throw_divide_data: function () {
        // console.log(this.player_throw_divide_data)
        this.parse_values(this.player_throw_divide_data)
      },
    }
  }
</script>

<style lang="css">
/*.highcharts-container,  svg { width: 100% !important;}*/
</style>
